import { leadSourceQueryKeys } from "@gymflow/api";
import { ApiListResponse, LeadSourceDTO } from "@gymflow/types";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ModalContext } from "../../../../../providers";
import useGymflowModels from "../../../../../store";
import { LeadSourceModal } from "../../../../organisms/LeadSourceModal";
import { SettingsIcon } from "../../../icons";
import { FormSelectInput, FormSelectInputProps } from "../FormSelectInput";

type FormSelectLeadSourceProps<T> = Omit<
  FormSelectInputProps<T, LeadSourceDTO>,
  "dataFetchingQuery"
>;

export const FormSelectLeadSource = <T,>(
  props: FormSelectLeadSourceProps<T>,
) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { stackModal } = useContext(ModalContext);
  return (
    <FormSelectInput
      placeholder={t("forms.leadSource.label")}
      label={t("forms.leadSource.label")}
      listButton={{
        title: t("forms.leadSource.create"),
        onClick: () => {
          stackModal(<LeadSourceModal />);
        },
        icon: <SettingsIcon className="size-5 stroke-gray-500" />,
      }}
      {...props}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: leadSourceQueryKeys.list({}),
          queryFn: async ({ pageParam }) =>
            (
              await api.leadSourceApi.find({
                limit: 10,
                page: pageParam,
                extraParams: { active: true },
              })
            ).data,
          select: (data) => {
            return {
              pageParams: data.pageParams,
              pages: data.pages.map((page) =>
                page.content.map((source) => ({
                  id: source.id,
                  label: source.name,
                  value: source,
                })),
              ),
            };
          },
          getNextPageParam: (lastPage: ApiListResponse<LeadSourceDTO>) =>
            lastPage.last ? undefined : lastPage.number + 1,
          initialPageParam: 0,
        })
      }
    />
  );
};
